<template>
  <div class="relative bg-white md:pt-20">
    <div class="relative w-full md:px-[5%] e1:m-auto e1:max-w-[1136px] e1:p-0">
      <div class="relative w-full cursor-pointer">
        <ExperienceDetailCarousel :img-urls="imgUrls" :on-click-expand="onClickExpand" />
      </div>
    </div>
  </div>
  <transition name="fade">
    <ExperienceDetailImageModal v-if="isOpen" :key="selectedIndex" class="z-inpage-modal" :img-urls="imgUrls" :initial-index="selectedIndex" :on-click-close="closeModal" />
  </transition>
</template>

<script lang="ts" setup>
import ExperienceDetailCarousel from '@/components/molecules/wabunka/ExperienceDetailCarousel/ExperienceDetailCarousel.vue';
import ExperienceDetailImageModal from '@/components/molecules/wabunka/ExperienceDetailImageModal/ExperienceDetailImageModal.vue';
import { useGlobalModal } from '@/composables/ui/useGlobalModal';

interface Props {
  imgUrls: string[];
  lang?: string;
}

withDefaults(defineProps<Props>(), {
  lang: 'jp',
});

const selectedIndex = ref<number>(0);

const { isOpen, open, close } = useGlobalModal('experienceDetailImageModal');

const closeModal = () => {
  close();
};

const onClickExpand = (e: MouseEvent, index: number) => {
  e.preventDefault();
  e.stopPropagation();
  selectedIndex.value = index;
  open();
};
</script>
